export const MAIN_TAB_INDEX = 0;
export const CATEGORIES_TAB_INDEX = 1;
export const SETTINGS_TAB_INDEX = 2;
export const LAYOUT_TAB_INDEX = 3;
export const DESIGN_TAB_INDEX = 4;
export const SUPPORT_TAB_INDEX = 5;
export const ADDONS_TAB_INDEX = 6;

export const biTabNames = {
  [MAIN_TAB_INDEX]: 'Main',
  [CATEGORIES_TAB_INDEX]: 'Categories',
  [SETTINGS_TAB_INDEX]: 'Settings',
  [LAYOUT_TAB_INDEX]: 'Layout',
  [DESIGN_TAB_INDEX]: 'Design',
  [SUPPORT_TAB_INDEX]: 'Support',
  [ADDONS_TAB_INDEX]: 'Add-Ons',
};

export const DESIGN_TAB_HEADER = 'design-tab.header';
export const DESIGN_TAB_POSTS = 'design-tab.posts';
export const DESIGN_TAB_ICONS_BUTTONS = 'design-tab.icons-buttons';

export const designTabNames = {
  0: DESIGN_TAB_HEADER,
  1: DESIGN_TAB_POSTS,
  2: DESIGN_TAB_ICONS_BUTTONS,
};



// WEBPACK FOOTER //
// ./app-settings/constants/constants.js